var exports = {
  "kL": "xfd349460--1192df--container" + " " + __webpack_require__(33767)["sectorWithSticky"],
  "om": "xfd349460--1192df--block",
  "Ei": "xfd349460--1192df--block_opened",
};

module.exports = exports;
